import React from 'react';
import { Fit, ItemText, Text, fs } from '../parts/fields';
import { Head, Logo } from '../parts/chrome';
import { items, str, useSlide } from '../parts/context';
import { formatDate } from '../text';

// #region TermsLayout
/** The offer in plain terms: label / value pairs, how long it stands, and a sign-off. */
export const TermsLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide, context, edit } = useSlide();
    const list = items(slide.fields.items);
    const n = list.length;
    const cols = n > 4 ? 2 : 1;
    const iso = str(slide.fields.valid_until).trim();
    const validUntil = iso ? formatDate(iso) : context.values.valid_until || '';
    const dense = n > 6;
    return (
        <>
            <div className="wd-pad">
                <Head />
                <Fit style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <dl style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`, columnGap: 88, maxWidth: cols === 1 ? 1320 : undefined }}>
                        {list.map((_, i) => (
                            <div key={i} style={{ display: cols === 1 ? 'grid' : 'block', gridTemplateColumns: '380px 1fr', columnGap: 48, alignItems: 'baseline',
                                padding: dense ? '22px 0' : '30px 0', borderTop: '1.5px solid var(--wd-line)', minWidth: 0 }}>
                                <ItemText as="dt" index={i} part="label" className="wd-eyebrow" style={{ fontSize: fs(20), marginBottom: cols === 1 ? 0 : 10, color: 'var(--wd-muted)' }} placeholder="Term" max={40} />
                                <ItemText as="dd" index={i} part="value" className="wd-h wd-clamp" style={{ fontSize: fs(dense ? 30 : 34), lineHeight: 1.25, letterSpacing: 0, fontWeight: 500, margin: 0 }} placeholder="What it means" max={120} />
                            </div>
                        ))}
                    </dl>
                    <footer style={{ marginTop: 'auto', paddingTop: 40, display: 'flex', alignItems: 'center', gap: 32 }}>
                        {validUntil ? <span className="wd-pill" style={{ fontSize: fs(22) }}>Valid until {validUntil}</span> : null}
                        {edit || str(slide.fields.signoff).trim() ? <Text k="signoff" className="wd-lead" style={{ fontSize: fs(26), fontStyle: 'italic', color: 'var(--wd-body)' }} placeholder="Sign-off (optional)" max={120} /> : null}
                    </footer>
                </Fit>
            </div>
            <Logo />
        </>
    );
};
